// extracted by mini-css-extract-plugin
export default {"wrapper":"Cart_wrapper__0WdHz","header":"Cart_header__yT2ed","line":"Cart_line__DMfb3","total":"Cart_total__85QoP","btn-checkout":"Cart_btn-checkout__8ZQT-"};